import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import UserAuth from './pages/UserAuth';

import UserDashboard from './pages/UserDashboard';

import Scenario from './pages/Scenario';
import ScenarioManagement from './pages/ScenarioManagement';
import UserManagement from './pages/UserManagement';
import UserPerformanceDetails from './pages/UserPerformanceDetails';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import FirstAidAnimation from './pages/FirstAidAnimation';



function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/user-login" element={<UserAuth/>} />
     
          <Route path="/user-dashboard" element={<UserDashboard />} />
          
          <Route path="/scenario/:id" element={<Scenario />} />
          {/* <Route path="/scenario-training" element={<ScenarioTraining />} /> */}
          <Route path="/scenario-management" element={<ScenarioManagement />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/user-performance/:userId" element={<UserPerformanceDetails />} />
          <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
          <Route path="/first-aid-animation" element={<FirstAidAnimation />} />
          
          {/* Add more routes as needed */}

        </Routes>
      </div>
    </Router>
  );
}

export default App;